import { create } from 'zustand';

interface GlobalLoaderState {
  isLoading: boolean;
  message: string;
  submessage: string;
  activeTasks: Set<string>;
  showTimeoutWarning: boolean;
  show: (message?: string, submessage?: string) => void;
  hide: () => void;
  startTask: (taskId: string, message?: string, submessage?: string) => void;
  endTask: (taskId: string) => void;
  setTimeoutWarning: (show: boolean) => void;
  reset: () => void;
}

let timeoutTimer: any = null;

export const useGlobalLoaderStore = create<GlobalLoaderState>((set, get) => ({
  isLoading: false,
  message: 'Task CRM',
  submessage: 'Carregando dados...',
  activeTasks: new Set<string>(),
  showTimeoutWarning: false,

  show: (message = 'Task CRM', submessage = 'Carregando dados...') => {
    if (timeoutTimer) clearTimeout(timeoutTimer);
    timeoutTimer = setTimeout(() => {
      set({ showTimeoutWarning: true });
    }, 6000);

    set({
      isLoading: true,
      message,
      submessage,
      showTimeoutWarning: false
    });
  },

  hide: () => {
    if (timeoutTimer) clearTimeout(timeoutTimer);
    set({
      isLoading: false,
      showTimeoutWarning: false,
      activeTasks: new Set<string>()
    });
  },

  startTask: (taskId: string, message = 'Task CRM', submessage = 'Carregando dados...') => {
    const tasks = new Set(get().activeTasks);
    tasks.add(taskId);

    if (timeoutTimer) clearTimeout(timeoutTimer);
    timeoutTimer = setTimeout(() => {
      set({ showTimeoutWarning: true });
    }, 6000);

    set({
      isLoading: true,
      activeTasks: tasks,
      message,
      submessage
    });
  },

  endTask: (taskId: string) => {
    const tasks = new Set(get().activeTasks);
    tasks.delete(taskId);
    const stillLoading = tasks.size > 0;

    if (!stillLoading && timeoutTimer) {
      clearTimeout(timeoutTimer);
    }

    set({
      activeTasks: tasks,
      isLoading: stillLoading,
      showTimeoutWarning: stillLoading ? get().showTimeoutWarning : false
    });
  },

  setTimeoutWarning: (show: boolean) => {
    set({ showTimeoutWarning: show });
  },

  reset: () => {
    if (timeoutTimer) clearTimeout(timeoutTimer);
    set({
      isLoading: false,
      message: 'Task CRM',
      submessage: 'Carregando dados...',
      activeTasks: new Set<string>(),
      showTimeoutWarning: false
    });
  }
}));
